import React, { useState, useEffect } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { Predio, PrediosPrograma, Programa, UserByDistance } from '../../../../service/types/types';
import { PrediosService } from '../../../../service/predios.service';
import PredioPrograma from './tables/programa/predioPrograma.table';
import ResumenPrograma from './tables/programa/resumenPrograma.table';
import PredioProgramaTurno from './tables/programa/predioProgramaTurno.table';
import SaveProgamaModal from './modals/savePrograma.modal';
import { ProgramaService } from '../../../../service/programa.service';
import { FeedbackModal } from '../../../common/feedback.modal';

export default function CreatePrograma() {
  const [predios, setPredios] = useState<PrediosPrograma[]>([]);
  const [prediosPrograma, setPredioPrograma] = useState<PrediosPrograma[]>([]);
  const [trabajadorPredio, setTrabajadorPredio] = useState<Map<string, string>>(new Map());

  //modal
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState<"success" | "error">("success");
  const [modalMessage, setModalMessage] = useState("");
  useEffect(() => {
    if(predios.length <= 0) {
      const fetchPredios = async () => {
        try {
          const data = await PrediosService.findAll();
          setPredios(data);
        } catch (error) {
          console.error('Error fetching users:', error);
        }
      };
      fetchPredios();
    }
  });
  const handleAddTrabajadorPredio = (rut: string, predioId: string) => {
    setTrabajadorPredio(prev => {
      const newMap = new Map(prev);
      newMap.set(rut, predioId);
      return newMap;
    });
  };
  const handleRemoveTrabajadorPredio = (rut: string) => {
    setTrabajadorPredio(prev => {
      const newMap = new Map(prev); // 👈 copia del Map actual
      newMap.delete(rut);            // 👈 elimina la entrada por clave
      return newMap;                // 👈 devuelve un nuevo Map → React re-renderiza
    });
  };

  const handleAddPredio = (predio: Predio) => {
     setPredioPrograma(prev => {
      const exists = prev.some(p => p.id === predio.id);
      if (exists) {
        return prev;
      }
      return [...prev, predio]; // agrega uno nuevo
    });
  };

  const handleDeletePredio = (predio: Predio) => {
     setPredioPrograma(prev => {
      const exists = prev.some(p => p.id === predio.id);
      if (exists) {
        return prev.filter(p => p.id !== predio.id);
      }
      return prev; // agrega uno nuevo
    });
  };

  const handleAddUser = (predio: PrediosPrograma, user: UserByDistance, turno: string) => {
    setPredioPrograma(prev =>
      prev.map(p => {
        if (p.id !== predio.id) return p; // deja los demás sin cambios
        if (turno === "M") {
          return { ...p, usersM: [...(p.usersM ?? []), user] };
        }
        if (turno === "T") {
          return { ...p, usersT: [...(p.usersT ?? []), user] };
        }
        if (turno === "N") {
          return { ...p, usersN: [...(p.usersN ?? []), user] };
        }
        // fallback: si no coincide ningún turno
        return p;
      })
    );
    handleAddTrabajadorPredio(user.rut, predio.id);
  };

  const handleRemoveUser = (predio: PrediosPrograma, user: UserByDistance, turno: string) => {
    setPredioPrograma(prev =>
      prev.map(p => {
        if (p.id !== predio.id) return p; // deja los demás sin cambios

        if (turno === "M") {
          return { ...p, usersM: (p.usersM ?? []).filter(u => u.rut !== user.rut) };
        }
        if (turno === "T") {
          return { ...p, usersT: (p.usersT ?? []).filter(u => u.rut !== user.rut) };
        }
        if (turno === "N") {
          return { ...p, usersN: (p.usersN ?? []).filter(u => u.rut !== user.rut) };
        }

        return p;
      })
    );
    handleRemoveTrabajadorPredio(user.rut);
  };
  
  const savePrograma = async (date: string, descripcion: string) => {
    const programa: Programa = {
      fecha: date,
      detalles: descripcion,
      prediosPrograma: prediosPrograma
    }
    try {
      await ProgramaService.create(programa)
      onSave(true);
    } catch (error: any) {
      console.log(error)
      onSave(false);
    };
  };

  const onSave = (isOk: boolean) => {
    if (isOk) {
      setModalType("success")
      setModalMessage("Programa Guardado Correctamente")
    } else {
      setModalType("error")
      setModalMessage("Error Guardado Programa")
    }
    setShowModal(true);
  };

  return (
    <Container fluid className="p-0" >
    <FeedbackModal
      show={showModal}
      onHide={() => setShowModal(false)}
      type={modalType}
      message={modalMessage}
      autoClose={true}   // 👈 se cierra solo en 3s
      duration={3000}
    />
    <div className="p-3">
      <Row>
        <Col className="d-flex align-items-center"><h4>Crear nuevo programa</h4></Col>
        <Col className="d-flex justify-content-end">
          <SaveProgamaModal savePrograma={savePrograma}/>
        </Col>
      </Row>
    </div>
    <div style={{ display: 'flex', width: '100%', overflowY: 'auto', padding: '1rem' }}>
      <div style={{  width: '40%', overflowY: 'auto', padding: '1rem' }}>
        <PredioPrograma
          rowsPerPage={5}
          predios={predios}
          onSelectPredio={handleAddPredio}
        />
      </div>
      <div style={{ width: '60%', padding: '1rem' }}>
        <PredioProgramaTurno
          rowsPerPage={5}
          predios={prediosPrograma}
          onSelectPredio={handleDeletePredio}
          onAddUser={handleAddUser}
          onRemoveUser={handleRemoveUser}
          trabajadorPredio={trabajadorPredio}
        />
      </div>
    </div>
    <div style={{ width: '100%', padding: '1rem' }}>
      <ResumenPrograma
          predios={prediosPrograma} />
    </div>
    </Container>
  );
}